<script setup>
import {
  KkIcon,
} from '../../../../components/base'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps({
  showEdit: {
    type: Boolean,
    default: false
  },
  showApproveDetail: {
    type: Boolean,
    default: false
  },
  showPreview: {
    type: Boolean,
    default: false
  },
  showCopy: {
    type: Boolean,
    default: false
  },
  showDelete: {
    type: Boolean,
    default: false
  },
  showCancelRequest: {
    type: Boolean,
    default: false
  },
  routeParameterEdit: {
    type: Object,
    default: () => ({
      name: '',
      params: {}
    }),
  },
  routeParameterCopy: {
    type: Object,
    default: () => ({
      name: '',
      params: {},
      query: {}
    }),
  },
})
const emit = defineEmits(['clickPreviewButton', 'clickDeleteButton', 'clickShowApproveButton', 'clickCancelRequestButton'])

const clickPreviewButton = ($event) => {
  emit('clickPreviewButton', $event)
}
const clickDeleteButton = ($event) => {
  emit('clickDeleteButton', $event)
}
const clickShowApproveButton = ($event) => {
  emit('clickShowApproveButton', $event)
}
const clickCancelRequestButton = ($event) => {
  emit('clickCancelRequestButton', $event)
}

</script>

<template>
  <div class="card__action c-button c-button--icon">
    <router-link v-if="props.showEdit" :to="props.routeParameterEdit" class="c-button__item">
      <KkIcon
        name="edit"
        color="rgba(58, 59, 63, 0.7)"
        class="c-button__icon"
      />
      {{ t('labels.edit') }}
    </router-link>

    <button v-if="props.showApproveDetail" class="c-button__item" @click="clickShowApproveButton">
      <KkIcon
        name="detail"
        color="rgba(58, 59, 63, 0.7)"
        class="c-button__icon"
      />
      {{ t('labels.confirmApplication') }}
    </button>

    <button v-if="props.showPreview" class="c-button__item" @click="clickPreviewButton">
      <KkIcon name="detail" color="rgba(58, 59, 63, 0.7)" class="c-button__icon" />
      {{ t('labels.preview') }}
    </button>

    <router-link v-if="props.showCopy" :to="props.routeParameterCopy" class="c-button__item">
      <KkIcon name="copy" color="rgba(58, 59, 63, 0.7)" class="c-button__icon" />
      {{ t('labels.copy') }}
    </router-link>

    <button v-if="props.showDelete" class="c-button__item" @click="clickDeleteButton">
      <KkIcon name="delete" color="rgba(58, 59, 63, 0.7)" class="c-button__icon" />
      {{ t('labels.delete') }}
    </button>

    <button v-if="props.showCancelRequest" class="c-button__item" @click="clickCancelRequestButton">
      <KkIcon name="delete" color="rgba(58, 59, 63, 0.7)" class="c-button__icon" />
      {{ t('labels.cancelRequest') }}
    </button>
  </div>
</template>
